import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineMax} from "gsap";
import {PearlHarbor} from "../../PearlHarbor";

export class PearlHarborFSBetPresentation implements FlowStatePresentation {
    private _tl: TimelineMax;
    private _flowStateController: FlowStateController;

    public start(flowStateController: FlowStateController) {
        // Fades out total win from previous spin if any
        this._flowStateController = flowStateController;
        this._tl = new TimelineMax();
        this._tl.add(() => {
            PearlHarbor.cocpitBoard.addAttention();
            PearlHarbor.cocpitBoard.spin();
        });
        this._tl.add(() => {this._flowStateController.finish();});
    }
}